import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../../css/ride.css';

const Row = ({ icon, label, sub, to, href, onClick }) => {
  const inner = (
    <>
      <span className="ride-row-ico"><i className={`bi ${icon}`} /></span>
      <span className="ride-row-main">
        <div className="ride-row-title">{label}</div>
        {sub && <div className="ride-row-sub">{sub}</div>}
      </span>
      <i className="bi bi-chevron-right chev" />
    </>
  );
  const cls = 'ride-rowlink';
  if (href) return <a className={cls} href={href} onClick={onClick} style={{ textDecoration: 'none', color: 'inherit' }}>{inner}</a>;
  return <Link className={cls} to={to} onClick={onClick} style={{ textDecoration: 'none', color: 'inherit' }}>{inner}</Link>;
};

export default function RideDrawer({ open, onClose }) {
  const { user, isAuthenticated } = useSelector((s) => s.auth);
  if (!open) return null;

  return (
    <>
      <div className="ride-drawer-mask" onClick={onClose} />
      <aside className="ride-drawer" role="dialog" aria-label="Menu">
        <div className="ride-drawer-head d-flex align-items-center gap-3">
          <img src={user?.avatar?.url || '/images/default_avatar.jpg'} alt="" />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 800 }}>{user?.name || 'Welcome'}</div>
            <div style={{ fontSize: '.78rem', opacity: 0.85, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {user?.phoneNo ? `0${user.phoneNo}` : 'Guest — sign in to book'}
            </div>
          </div>
        </div>

        <div className="ride-drawer-scroll" onClick={onClose}>
          <Row icon="bi-house-door" label="Home" to="/ride" />
          <Row icon="bi-journal-text" label="My rides" to="/ride/rides" />
          <Row icon="bi-person-circle" label="Account" to="/ride/account" />
          <Row icon="bi-question-circle" label="Help & support" href="tel:+923000000000" sub="Call us daily 9am–9pm" />

          <div className="ride-drawer-group-label">Account</div>
          {isAuthenticated ? (
            <>
              <Row icon="bi-person-gear" label="Edit profile" to="/me/update_profile" />
              <Row icon="bi-key" label="Change password" to="/me/update_password" />
            </>
          ) : (
            <>
              <Row icon="bi-box-arrow-in-right" label="Sign in" to="/login" />
              <Row icon="bi-person-plus" label="Create account" to="/register" />
            </>
          )}

          {(user?.role === 'driver') && (
            <>
              <div className="ride-drawer-group-label">Driver</div>
              <Row icon="bi-list-check" label="Driver dashboard" to="/driver/potential-local-bookings" />
            </>
          )}
          {user?.role === 'admin' && (
            <>
              <div className="ride-drawer-group-label">Admin</div>
              <Row icon="bi-speedometer2" label="Admin panel" to="/admin/bookings" />
            </>
          )}

          <div className="ride-drawer-group-label">More</div>
          <Row icon="bi-truck" label="Transport booking" to="/create-booking/local" sub="Freight & load moving" />
          <Row icon="bi-taxi-front" label="Driver registration" to="/driver/register" sub="Drive with MBZ" />
        </div>

        <div className="ride-drawer-foot">
          <span className="small text-muted">MBZ Rides · v2</span>
        </div>
      </aside>
    </>
  );
}
